import { render, staticRenderFns } from "./OnboardingNewUser.vue?vue&type=template&id=ba98a13c"
import script from "./OnboardingNewUser.vue?vue&type=script&lang=js"
export * from "./OnboardingNewUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports